import React from 'react';

import { AnimacaoConfirmacao } from 'Component/Animacao';
import Botao from 'Component/Botao';
import BotaoLink from 'Component/BotaoLink';
import { LTI } from 'Interface/Aulas';

const FormLTI = ({ lti: { dados, assinatura, url } }: LTI): React.ReactElement =>
{
    return (
        <form id="ltiLaunchForm" className="animate__animated animate__fadeIn" name="ltiLaunchForm" method="POST" action={ url } target="_blank">
            { Object.keys(dados).map(chave => (
                <input
                    key={ chave }
                    type="hidden"
                    name={ chave }
                    value={ dados[chave as string] }
                />
            )) }
            <input type="hidden" name="oauth_signature" value={ assinatura } />
            <div className="d-flex flex-column justify-content-center">
                <div className="d-flex justify-content-center mb-5">
                    <AnimacaoConfirmacao />
                </div>
                <p className="lead text-muted text-center">
                    Obrigado por esperar! Sua aula já está pronta...
                </p>
                <Botao lg tema="success" type="submit">
                    Clique aqui para abri-la
                </Botao>
                <BotaoLink
                    lg
                    tema="outline-light"
                    className="mt-3"
                    to={ dados.launch_presentation_return_url.replace('http://0.0.0.0:8765', '').replace('https://plus.estudesemfronteiras.com', '') }
                >
                    Voltar para o curso
                </BotaoLink>
            </div>
        </form>
    );
}

export default FormLTI;
